import { Link } from 'react-router-dom';

const prototypes = [
  {
    path: '/lab/immersive-reading',
    label: 'Prototype 01',
    title: 'Live Session',
    summary: '카드를 한 장씩 넘기면서 타로이스트가 바로 앞에서 이어 말하는 세션형 리딩.',
    bullets: ['첫인상 -> 해석 -> 연결 -> 브릿지 리듬', '실제 리더가 카드를 넘겨 보는 감각', '3장 스프레드 몰입 강화'],
  },
  {
    path: '/lab/ritual-journey',
    label: 'Prototype 02',
    title: 'Guided Ritual',
    summary: '질문을 바로 해석하지 않고, 감정을 예열하고 질문의 진짜 이름을 찾아가는 의식형 흐름.',
    bullets: ['질문 전 예열 단계', '반성 질문과 감정 준비', '리딩을 세션이 아니라 여정으로 체감'],
  },
  {
    path: '/lab/reader-styles',
    label: 'Prototype 03',
    title: 'Reader Styles',
    summary: '같은 카드라도 리더 스타일에 따라 어떻게 분위기와 몰입이 달라지는지 비교하는 실험.',
    bullets: ['리더 보이스 선택', '실시간 스트리밍 해설 리듬', '브랜드 톤 튜닝 실험에 적합'],
  },
] as const;

export default function ReadingLabIndexPage() {
  return (
    <main className="min-h-screen bg-[#070609] text-[#f7efe3]">
      <div className="pointer-events-none fixed inset-0 -z-10 bg-[radial-gradient(circle_at_top,_rgba(198,145,90,0.18),_transparent_35%),radial-gradient(circle_at_80%_10%,_rgba(106,68,150,0.2),_transparent_28%),linear-gradient(180deg,_#100c12_0%,_#070609_55%,_#070609_100%)]" />

      <section className="mx-auto max-w-[1380px] px-5 pb-16 pt-20 lg:px-10">
        <div className="max-w-4xl border-b border-white/10 pb-10">
          <p className="text-[11px] uppercase tracking-[0.42em] text-[#c89b61]">Myoan Prototype Lab</p>
          <h1 className="mt-4 font-['Song_Myung'] text-4xl leading-[1.05] text-[#fff8ed] sm:text-5xl lg:text-6xl">
            LLM 몰입감 실험실
          </h1>
          <p className="mt-6 max-w-3xl text-sm leading-8 text-[#d7c9b3] sm:text-base">
            현재 운영 중인 결과 페이지를 건드리지 않고, 묘안 타로의 해석 톤과 연출 방식을 따로 실험하는 임시 페이지 모음입니다.
            목표는 보고서를 출력하는 AI가 아니라, 카드를 실제로 펼쳐 보며 이야기를 이어 가는 타로이스트처럼 느껴지게 만드는 것입니다.
          </p>
        </div>

        <div className="mt-10 grid gap-6 lg:grid-cols-3">
          {prototypes.map((prototype) => (
            <article
              key={prototype.path}
              className="rounded-[28px] border border-white/10 bg-white/[0.03] p-6 shadow-[0_24px_90px_rgba(0,0,0,0.32)] backdrop-blur"
            >
              <p className="text-[11px] uppercase tracking-[0.34em] text-[#c89b61]">{prototype.label}</p>
              <h2 className="mt-4 text-3xl font-semibold text-[#fff6ea]">{prototype.title}</h2>
              <p className="mt-4 text-sm leading-8 text-[#d9cbb7]">{prototype.summary}</p>

              <ul className="mt-6 space-y-3 text-sm leading-7 text-[#efe2cf]">
                {prototype.bullets.map((bullet) => (
                  <li key={bullet} className="rounded-2xl border border-white/8 bg-black/10 px-4 py-3">
                    {bullet}
                  </li>
                ))}
              </ul>

              <Link
                to={prototype.path}
                className="mt-8 inline-flex rounded-full bg-[#f5eee4] px-5 py-2 text-sm font-medium text-[#110d11] transition hover:bg-white"
              >
                실험 열기
              </Link>
            </article>
          ))}
        </div>

        <div className="mt-10 rounded-[28px] border border-[#c89b61]/20 bg-[#110d10] p-6">
          <p className="text-[11px] uppercase tracking-[0.34em] text-[#c89b61]">Reference Patterns</p>
          <div className="mt-4 grid gap-4 lg:grid-cols-3">
            <article className="rounded-2xl border border-white/8 bg-white/[0.03] p-4 text-sm leading-7 text-[#d8c9b4]">
              <p className="font-semibold text-[#fff5e8]">Sanctuary</p>
              <p className="mt-2">라이브 1:1 리딩 감각. 앱 안에서도 사람이 답해주는 것처럼 이어지는 대화 리듬이 강합니다.</p>
            </article>
            <article className="rounded-2xl border border-white/8 bg-white/[0.03] p-4 text-sm leading-7 text-[#d8c9b4]">
              <p className="font-semibold text-[#fff5e8]">CHANI</p>
              <p className="mt-2">질문을 바로 풀이하지 않고, 감정과 리듬을 준비시키는 가이드형 구조가 돋보입니다.</p>
            </article>
            <article className="rounded-2xl border border-white/8 bg-white/[0.03] p-4 text-sm leading-7 text-[#d8c9b4]">
              <p className="font-semibold text-[#fff5e8]">Tarovent</p>
              <p className="mt-2">스프레드 구조와 리더 스타일, 실시간 해석 스트리밍을 전면에 내세우는 점이 참고 포인트였습니다.</p>
            </article>
          </div>
        </div>
      </section>
    </main>
  );
}
